export default "__VITE_ASSET__B$IgONFZ__"